(function () {
    'use strict';

    angular
        .module('initiativeUpdateStatusRoutes', [
            'initiativeUpdateStatusAssessRoutes',
            'initiativeUpdateStatusReviewRoutes',
            'initiativeUpdateStatusControllers'
        ])
        .config(router);

    router.$inject = ['$stateProvider', 'historyCtxtServiceProvider'];

    function router($stateProvider, historyCtxtServiceProvider) {
        $stateProvider
             .state('initiativeUpdateStatusOwnerList', {
                 url: '/InitiativeUpdateStatus/Owner',
                 data: {
                     permissions: { featureRole: 'GRCInitiativeUpdateStatusManagement', key: 'PlanInitiative', permission: 'Manage' }
                 },
                 resolve: {
                     activeProcess: ['grcGovernanceProcessService', function (service) {
                         return service.getActiveInitiativeUpdateStatus();
                     }]
                 },
                 views: {
                     '': {
                         templateUrl: require('./initiativeUpdateStatus.tpl.html'),
                         controller: 'InitiativeUpdateStatusController'
                     },
                     'mainContent@initiativeUpdateStatusOwnerList': {
                         templateUrl: require('./ownersList.tpl.html'),
                         controller: 'InitiativeUpdateStatusOwnersListController',
                         resolve: {
                             planLookups: ['businessPlanningService', function (service) {
                                 return service.getPlanLookups();
                             }],
                             owners: ['businessPlanningService', function (service) {
                                 return service.getOwnersAndStatus();
                             }]
                         }
                     }
                 }
             })

            .state('initiativeUpdateStatusOwnerList.noActiveProcess', {
                url: '/NoActiveProcess',
                views: {
                    'mainContent@initiativeUpdateStatusOwnerList': {
                        templateUrl: require('./withNoActiveProcess.tpl.html'),
                        controller: 'InitiativeUpdateStatusWithNoActiveProcessController',
                    }
                }
            })

            .state('initiativeUpdateStatusEligibleForAssessment', {
                url: '/InitiativeUpdateStatus/EligibleForAssessment',
                data: {
                    permissions: {featureRole: 'GRCInitiativeUpdateStatusManagement', key: 'PlanInitiative', permission: 'Manage'}
                },
                views: {
                    '': {
                        templateUrl: require('./eligibleForAssessment.tpl.html'),
                        controller: 'InitiativeUpdateStatusEligibleForAssessmentController',
                        resolve: {
                            eligibleOwnersForAssessment: ['initiativeUpdateStatusService', function (service) {
                                return service.getEligibleAssessmentCreationOwners();
                            }]
                        }
                    }
                }
            });

        historyCtxtServiceProvider.setCtxtState('aricControlOwnerList.byOwner',
            '/app/Main/initiativeUpdateStatus/GOVHistoryCtxtDirective-owner.tpl.html'
        );
    }
})();